// extracted by mini-css-extract-plugin
export var card = "_pa-0";
export var content = "_pa-2";
export var details = "_pa-3";
export var icon = "_pa-1";
export var iconBlue = "_pa-5";
export var iconBrand = "_pa-4";
export var iconGrayBlue = "_pa-6";
export var iconGreen = "_pa-7";
export var iconIndigo = "_pa-8";
export var iconOrange = "_pa-9";
export var iconPurple = "_pa-a";
export var iconRed = "_pa-b";
export var iconWarning = "_pa-c";